import { PROJECT_NOTIFICATION_ENTITY_TYPE } from './constants';
import { PROJECT_NOTIFICATION_CONFIRM_ACTIONS } from './types';

type NotificationRouteResolvers = {
  getControlsUrl: (projectId: string) => string;
  getAssumptionsUrl: (projectId: string) => string;
  getStakeholdersUrl: (projectId: string) => string;
  getEngineeringUrl: (projectId: string) => string;
};

export const getProjectNotificationTargetUrl = ({
  confirmAction,
  entityType,
  projectId,
  routes,
}: {
  confirmAction?: string;
  entityType?: string;
  projectId: string;
  routes: NotificationRouteResolvers;
}) => {
  if (confirmAction === PROJECT_NOTIFICATION_CONFIRM_ACTIONS.CONFIRM_STAKEHOLDER_LIST) {
    return routes.getStakeholdersUrl(projectId);
  }

  if (entityType === PROJECT_NOTIFICATION_ENTITY_TYPE.ASSUMPTION) {
    return routes.getAssumptionsUrl(projectId);
  }

  if (entityType === PROJECT_NOTIFICATION_ENTITY_TYPE.ENGINEERING) {
    return routes.getEngineeringUrl(projectId);
  }

  return routes.getControlsUrl(projectId);
};

export const getProjectNotificationActionLabel = (entityType?: string) => {
  switch (entityType) {
    case PROJECT_NOTIFICATION_ENTITY_TYPE.ASSUMPTION:
      return 'Open project assumptions';
    case PROJECT_NOTIFICATION_ENTITY_TYPE.ENGINEERING:
      return 'Open project engineering';
    case PROJECT_NOTIFICATION_ENTITY_TYPE.PROJECT:
    default:
      return 'Open project';
  }
};
